import React, { useState, useEffect } from "react";
import { useHistory, withRouter } from "react-router-dom";
import { Menu } from "antd";
import {
  DashboardOutlined,
  UserOutlined,
  HomeOutlined,
} from "@ant-design/icons";
import { useSelector } from "react-redux";

const SidebarContent = ({ location }) => {
  const history = useHistory();
  const userRole = useSelector((state) => state.roleReducer.userRole);
  const [isCondensed, setIsCondensed] = useState(window.innerWidth <= 767);

  useEffect(() => {
    const handleResize = () => setIsCondensed(window.innerWidth <= 767);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const adminItems = [
    {
      key: "/dashboard",
      icon: <DashboardOutlined />,
      label: "Dashboard",
    },
    {
      key: "/user",
      icon: <UserOutlined />,
      label: "User Master",
    },
    {
      key: "/address",
      icon: <HomeOutlined />,
      label: "Address Master",
    },
  ];

  const userItems = [
    {
      key: "/dashboard",
      icon: <DashboardOutlined />,
      label: "Dashboard",
    },
    {
      key: "/address",
      icon: <HomeOutlined />,
      label: "Address Master",
    },
  ];

  const items = userRole === "admin" ? adminItems : userItems;

  return (
    <Menu
      mode="inline"
      theme="light"
      inlineCollapsed={isCondensed}
      selectedKeys={[location ? location.pathname : ""]}
      items={items}
      onClick={({ key }) => history.push(key)}
      style={{ borderInlineEnd: "none" }}
    />
  );
};

export default withRouter(SidebarContent);
